import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {FormlyFieldConfig, FormlyFormOptions} from '@ngx-formly/core';
import {environment} from '../../../../../../environments/environment';
import {DealerRole} from '../../../../../dealer-system/Models/DealerRole';
import {SystemUser} from '../../../../../shared/Models/SystemUser';
import {TranslateService} from '@ngx-translate/core';
import {UsersService} from '../../../../../back-office/Services/users.service';
import {AuthenticationService} from '../../../../../shared/Services/authentication.service';
import {BroadcastService} from '../../../../../shared/Services/broadcast.service';

@Component({
  selector: 'app-manage-dealer-user',
  templateUrl: './manage-dealer-user.component.html',
  styleUrls: ['./manage-dealer-user.component.scss']
})
export class ManageDealerUserComponent implements OnInit {
  public modalTitle;
  public isEdit = false;
  public classicForm = new UntypedFormGroup({});
  public lastValue: any;
  public manageDealerUser;
  public roles = [];
  public options: FormlyFormOptions = {};
  @ViewChild('modal', {static: false}) modal;
  @Input() showModal = false;

  @Output() notifyParent: EventEmitter<any> = new EventEmitter();
  @Input() userInput;
  @Input() manageProfile = false;

  @Input() refresh: number;

  constructor(
    private userService: UsersService,
    private translator: TranslateService,
    private auth: AuthenticationService,
    private broadcastService: BroadcastService) {
  }

  ngOnInit() {
    this.userService.getUserRoles().subscribe((roles) => {
      const roleItem = roles.data;
      if (this.roles.length === 0) {
        roleItem.map((value) => {
          this.roles.push({
            label: this.translator.instant(value.name),
            value: value.id,
            disabled: value.name === DealerRole.ROLE_ADMIN
          });
        });
      }
      this.initialForm();
    });
  }

  hideModal() {
    this.modal.hide();
    this.showModal = false;
    /*   this.options.resetModel();*/
    /*   this.broadcastService.broadcast('refreshGrid', 'getUserEmployee');*/
  }

  initialForm() {
    this.modal.show();
    const status = false;
    if (status) {
      this.modalTitle = this.translator.instant('admin.dealer.account.edit_user');
    } else {
      this.isEdit = false;
      this.modalTitle = this.translator.instant('admin.dealer.account.add_user');
    }
    this.manageDealerUser = <FormlyFieldConfig>[
      {
        fieldGroupClassName: 'row',
        key: 'user',
        fieldGroup: [
          {
            className: 'col-6 ',
            type: 'input',
            key: 'firstName',
            templateOptions: {
              label: this.translator.instant('doctrine.user.firstName'),
              required: true,
              pattern: '[a-zA-Z _-]+',
              maxLength: environment.maxStringLength,
            },
            validation: {
              messages: {
                pattern: this.translator.instant('errors.invalid'),
                required: this.translator.instant('errors.required'),
                maxlength: (error, field: FormlyFieldConfig) => this.translator.instant('validators.max_message',
                  {limit: field.templateOptions.maxLength})
              },
            },
          },
          {
            className: 'col-6',
            type: 'input',
            key: 'lastName',
            templateOptions: {
              label: this.translator.instant('doctrine.user.lastName'),
              required: true,
              pattern: '[a-zA-Z _-]+',
              maxLength: environment.maxStringLength,
            },
            validation: {
              messages: {
                pattern: this.translator.instant('errors.invalid'),
                required: this.translator.instant('errors.required'),
                maxlength: (error, field: FormlyFieldConfig) => this.translator.instant('validators.max_message',
                  {limit: field.templateOptions.maxLength})
              },
            },
          },
        ],
      },
      {
        fieldGroupClassName: 'row',
        key: 'user',
        fieldGroup: [
          {
            className: 'col-6 ',
            type: 'input',
            key: 'username',
            pattern: '[a-zA-Z _-]+',
            templateOptions: {
              label: this.translator.instant('doctrine.user.username'),
              required: true,
              maxLength: environment.maxStringLength,
            },
            validation: {
              messages: {
                required: this.translator.instant('errors.required'),
                pattern: this.translator.instant('errors.invalid'),
                maxlength: (error, field: FormlyFieldConfig) => this.translator.instant('validators.max_message',
                  {limit: field.templateOptions.maxLength})
              },
            },
          },
          {
            className: 'col-6 ',
            type: 'input',
            key: 'email',
            templateOptions: {
              label: this.translator.instant('doctrine.user.email'),
              required: false,
              maxLength: environment.maxStringLength,
              pattern: environment.emailPattern,
            },
            validation: {
              messages: {
                pattern: this.translator.instant('errors.invalid'),
                required: this.translator.instant('errors.required'),
                maxlength: (error, field: FormlyFieldConfig) => this.translator.instant('validators.max_message',
                  {limit: field.templateOptions.maxLength})
              },
            },
          },
        ],
      },
      {
        fieldGroupClassName: 'row',
        key: 'auth',
        validators: {
          fieldMatch: {
            expression: (control) => {
              const value = control.value;
              if (!this.manageProfile || !this.isEdit) {
                return value.plainPasswordConfirm === value.plainPassword || (!value.plainPasswordConfirm && !value.plainPassword);
              }
              return true;
            },
            message: this.translator.instant('errors.passwordMatch'),
            errorPath: 'plainPasswordConfirm',
          },
        },
        fieldGroup: [
          {
            className: 'col-6',
            type: 'input',
            key: 'plainPassword',
            templateOptions: {
              label: this.translator.instant('doctrine.user.plainPassword'),
              required: !this.isEdit,
              type: 'password',
              minLength: environment.minPassword,
              maxLength: environment.maxStringLength,
            },
            validation: {
              messages: {
                minLength: this.translator.instant('validators.password.length.min',
                  {limit: environment.minPassword}),
                maxLength: this.translator.instant('validators.password.length.max',
                  {limit: environment.maxStringLength}),
                pattern: this.translator.instant('errors.invalid'),
                required: this.translator.instant('errors.required'),
                lowerCase: this.translator.instant('validators.password.contain.lowercase'),
                uppercase: this.translator.instant('validators.password.contain.uppercase'),
                number: this.translator.instant('validators.password.contain.number'),
                special: this.translator.instant('validators.password.contain.special'),
              },
            },
            validators:  {
              validation: ['lowerCase', 'uppercase', 'number', 'special'],
            },
          },
          {
            className: 'col-6',
            type: 'input',
            key: 'plainPasswordConfirm',
            templateOptions: {
              type: 'password',
              label: this.translator.instant('admin.dealer.account.confirm_new_password'),
              required: !this.isEdit
            }
          }]
      },
      {
        fieldGroupClassName: 'row',
        key: 'user',
        fieldGroup: [
          {
            key: 'role',
            type: 'ng-select',
            className: 'col-6 ',
            defaultValue: this.roles.find(role => role.label === this.translator.instant(DealerRole.ROLE_MODERATOR)).value,
            templateOptions: {
              label: this.translator.instant('doctrine.user.role'),
              required: true,
              options: this.roles,
            },
            expressionProperties: {
              'templateOptions.disabled': (model: any) => {
                if (model !== undefined && model != null) {
                  return this.manageProfile;
                }
              },
            },
            validation: {
              messages: {
                required: this.translator.instant('errors.required'),
              },
            },
          },
          {
            key: 'status',
            type: 'ng-select',
            className: 'col-6 ',
            defaultValue: SystemUser.SYSTEMUSER_ACTIVE,
            templateOptions: {
              label: this.translator.instant('doctrine.user.status'),
              required: true,
              options: [
                {label: this.translator.instant('global.active'), value: SystemUser.SYSTEMUSER_ACTIVE},
                {label: this.translator.instant('global.inactive'), value: SystemUser.SYSTEMUSER_INACTIVE},
              ],
            },
            validation: {
              messages: {
                required: this.translator.instant('errors.required'),
              },
            },
          },
        ],
      },

    ];

  }

  saveDealerUser() {

  }


}
